export default __webpack_public_path__ + "static/media/screenshot13.ad9ac960.jpg";